import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr2004',
    ecrans: ['00-2'],
    params: [ 'dpocleint', '?loecleint']
});
